import ApiClient from '../../services/apiClient';
import { LookupDataEnums } from '../../utilities/Constants';
import { useQuery } from 'react-query';

const _apiClient = new ApiClient();

export const useGetLookupData = (lookupType: LookupDataEnums) => {
    return useQuery({
        queryKey: ['get-lookup-data', lookupType],
        queryFn: async () => {
            const response = await _apiClient.getLookupData(lookupType);

            if (response.httpResponse.status === 401) {
                window.location.reload();
            }

            if (response.httpResponse.status === 500) {
                throw new Error(`Failed to retrieve lookup data for ${lookupType}`);
            } else if (response.errorMessage) {
                throw new Error(response.errorMessage);
            }

            return response.payload;
        },
        staleTime: Infinity,
        cacheTime: Infinity,
    });
};
